<rask-header [uppercase]="true">
    Virkesleverantörer
</rask-header>
<rask-container-block>
    <ng-container header>Validera momsregnummer</ng-container>
    <div class="row">
        <div class="col">
            <rask-input label="LeverantörsId" [(ngModel)]="leverantorsId"></rask-input>
            <rask-input label="Momsregnummer" [(ngModel)]="momsnummer"></rask-input>
            <rask-button color="secondary" (click)="validateMomsnummer()">Validera</rask-button>
        </div>
    </div>
    <div class="row">
        @if(momsnummerOk && momsnummerEjValiderad === false){
        <div class="col-md-2 offset-md-1" style="color: green;">Momsnummer ok!</div>
        }
        @if(!momsnummerOk && momsnummerOk !== undefined && momsnummerEjValiderad === false)
        {
        <div class="col-md-2 offset-md-1" style="color: red;">Momsnummer ej ok!</div>
        }
        @if(momsnummerEjValiderad){
        <div class="col-md-2 offset-md-1" style="color: red;">Momsnummer ej validerat!</div>
        }
    </div>
</rask-container-block>

<rask-container-block>
    <ng-container header>Validera alla virkesleverantörers momsregistreringsnummer</ng-container>
    <rask-button color="secondary" (click)="validateAllVirkesleverantorerMomsregnr()">Validera allas
        momsregistreringsnummer</rask-button>
</rask-container-block>